import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { toCurrency } from '../util/toCurrency';
import { Price } from '../styles/Price';
import { color } from '../styles/helpers/variables';

const RenderPrice = props => {
  const isOnSale = props.originalPrice && props.price < props.originalPrice;
  const priceWithCurrentOptions = props.price + props.currentOptionsPrice;
  const originalPriceWithCurrentOptions = props.originalPrice + props.currentOptionsPrice;

  if (isOnSale) {
    return (
      <RenderPriceContainer inline={props.inline} productPage={props.productPage}>
        <Price
          fontWeight={props.fontWeight}
          fontSize={props.fontSize}
          inline
          small={props.small}
          sale={originalPriceWithCurrentOptions}
        >
          {props.priceFrom ? <PriceFromText>Från</PriceFromText> : false} {toCurrency(priceWithCurrentOptions)}
        </Price>
        <Price fontSize={props.fontSize} small={props.small} inline originalPrice>
          ({toCurrency(originalPriceWithCurrentOptions)})
        </Price>
      </RenderPriceContainer>
    );
  }

  return (
    <RenderPriceContainer inline={props.inline} productPage={props.productPage}>
      <Price
        inline={props.inline}
        fontWeight={props.fontWeight}
        fontSize={props.fontSize}
        small={props.small}
        sale={isOnSale}
      >
        {props.priceFrom ? <PriceFromText>Från</PriceFromText> : false} {toCurrency(priceWithCurrentOptions)}
      </Price>
    </RenderPriceContainer>
  );
};

const RenderPriceContainer = styled.div`
  margin-bottom: 1em;
  margin-top: 0.35em;

  ${props =>
    props.inline &&
    css`
      display: inline-block;
      margin: 0;
    `};
  ${props =>
    props.productPage &&
    css`
      margin: 0 0 30px;
    `};
`;

const PriceFromText = styled.span`
  color: ${color.darkerGrey};
  font-size: 12px;
  text-transform: uppercase;
`;

RenderPrice.defaultProps = {
  fontWeight: '600',
  inline: false,
  fontSize: null,
  small: false,
  currentOptionsPrice: null,
  price: null,
  originalPrice: null,
  priceFrom: false,
  productPage: false
};

RenderPrice.propTypes = {
  inline: PropTypes.bool,
  fontSize: PropTypes.string,
  small: PropTypes.bool,
  fontWeight: PropTypes.string,
  currentOptionsPrice: PropTypes.number,
  price: PropTypes.number,
  originalPrice: PropTypes.number,
  priceFrom: PropTypes.bool,
  productPage: PropTypes.bool
};

export default RenderPrice;



// WEBPACK FOOTER //
// ./src/components/RenderPrice.js